<template>
  <Navbar />
  <Header v-bind:title="title" />

    <section class="content-section" v-if="downloads.length">
        <ul v-for="download in downloads" :key="download.id">
            <li class="list">
                <a target="_blank" v-bind:title="download.title+'(直接下載)'" v-bind:href="download.url">
                    <font-awesome-icon icon="fas fa-angle-double-right" /> {{ download.title }}
                </a>
            </li>
        </ul>
        <!-- <div class="pagination-wrapper" id="pagination"></div> -->
    </section>
    <section class="content-section" v-else>
        <Loader />
    </section>
                     
  <Footer />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Loader from "@/components/Loader.vue";

export default {
  name: "App",
  components: { Navbar, Header, Footer, Loader },
  data() {
    return {
      title: "表單下載",
      downloads: []
    };
  },

  mounted() {
    fetch('https://oir.nccu.edu.tw/codeigniter/api/downloads')
    .then((respond) => respond.json())
    .then((data) => {
        data.forEach(element => {     
            this.downloads.push(element);
        });
    })
    .catch((err) => console.log(err.message))
  }
};
</script>

<style src="@/assets/css/list.css" scoped></style>